import { getPartnerByKey } from '@/appSettings/Partners'
import type { Partner } from 'BrokerTsLib/src/enums'
import { useImpersonateMutation } from 'BrokerTsLib/src/hooks'
import { useEffect, useRef } from 'react'

export const useSwitchPartner = () => {
  const { mutateAsync: impersonate, isSuccess: impersonated, reset: resetImpersonation } = useImpersonateMutation()
  const switchingPartner = useRef<keyof typeof Partner | null>(null)
  const switchToPartner = (partner: number, enumKey: keyof typeof Partner) => {
    let userName = 'administrator'
    if (partner !== 1) userName += partner
    
    switchingPartner.current = enumKey
    
    return impersonate(userName)
  }
      
  useEffect(() => {
    if (!impersonated || !switchingPartner.current) 
      return
    
    const partner = getPartnerByKey(switchingPartner.current)
    const host = partner?.hosts?.at(0)
    if (host && host !== window.location.host) {
      if (window.location.host !== 'localhost')
        console.debug(`Switching to partner ${partner?.partner} (${host})`)
      else
        window.location.host = host
    }
    else {
      window.location.reload()
    }
        
    resetImpersonation()
  }, [impersonated, resetImpersonation])

  return switchToPartner
}